import { Stack, Typography } from '@mui/material'
import { useRouteError, isRouteErrorResponse } from 'react-router-dom'

export default function ErrorPage() {
  const error = useRouteError()

  if (isRouteErrorResponse(error)) {
    // Handles 404, 401, etc.
    return (
      <Stack textAlign="center" mt={5} spacing={2}>
        <Typography variant="h4" color="error">
          {error.status} - {error.statusText}
        </Typography>
        <Typography variant="body2" color="error">
          {error.data}
        </Typography>
      </Stack>
    )
  }

  return (
    <div>
      <h1>Something went wrong 😢</h1>
      <p>{(error as Error)?.message}</p>
    </div>
  )
}
